import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgParkTheBus = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 100 100",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("style", { children: "\n      .cls-1 {\n        fill: url(#New_Gradient_Swatch);\n      }\n\n      .cls-2 {\n        fill: url(#New_Gradient_Swatch-3);\n      }\n\n      .cls-3 {\n        fill: url(#New_Gradient_Swatch-2);\n      }\n\n      .cls-4 {\n        fill: none;\n        stroke: url(#New_Gradient_Swatch-4);\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n    " }),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "New_Gradient_Swatch",
				"data-name": "New Gradient Swatch",
				x1: 29.76,
				y1: 64.64,
				x2: 40.33,
				y2: 64.64,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#4d04b1"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .98,
					stopColor: "#887ebb"
				})]
			}),
			/* @__PURE__ */ _jsx("linearGradient", {
				id: "New_Gradient_Swatch-2",
				"data-name": "New Gradient Swatch",
				x1: 60.78,
				x2: 71.34,
				xlinkHref: "#New_Gradient_Swatch"
			}),
			/* @__PURE__ */ _jsx("linearGradient", {
				id: "New_Gradient_Swatch-3",
				"data-name": "New Gradient Swatch",
				x1: 20.7,
				y1: 47.36,
				x2: 92.49,
				y2: 47.36,
				xlinkHref: "#New_Gradient_Swatch"
			}),
			/* @__PURE__ */ _jsx("linearGradient", {
				id: "New_Gradient_Swatch-4",
				"data-name": "New Gradient Swatch",
				x1: 5.17,
				y1: 50,
				x2: 94.83,
				y2: 50,
				xlinkHref: "#New_Gradient_Swatch"
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M35.04,59.36c-2.92,0-5.28,2.36-5.28,5.28s2.37,5.28,5.28,5.28,5.28-2.36,5.28-5.28-2.37-5.28-5.28-5.28ZM35.04,66.94c-1.27,0-2.3-1.03-2.3-2.3s1.03-2.3,2.3-2.3,2.3,1.03,2.3,2.3-1.03,2.3-2.3,2.3Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-3",
				d: "M66.06,59.36c-2.92,0-5.28,2.36-5.28,5.28s2.36,5.28,5.28,5.28,5.28-2.36,5.28-5.28-2.36-5.28-5.28-5.28ZM66.06,66.94c-1.27,0-2.3-1.03-2.3-2.3s1.03-2.3,2.3-2.3,2.3,1.03,2.3,2.3-1.03,2.3-2.3,2.3Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M76.14,30.07H27.65c-1.74,0-3.44,1.39-3.79,3.09l-2.53,14.81c-.35,1.7-.63,4.51-.63,6.25l.16,7.26c0,1.74,1.42,3.16,3.16,3.16h4.8c0-3.43,2.79-6.23,6.23-6.23s6.23,2.79,6.23,6.23h18.55c0-3.43,2.8-6.23,6.23-6.23s6.23,2.79,6.23,6.23h3.85c1.73,0,3.15-1.42,3.15-3.16v-28.25c0-1.74-1.42-3.16-3.15-3.16ZM35.56,51.29h-7.36l1.16-2.76c.2-.48-.02-1.04-.5-1.24-.48-.2-1.04.02-1.24.51l-1.47,3.48c-2.75-.12-3.14-1.12-2.92-2.31l.84-5.68h11.49v8ZM35.56,39.81h-10.97l.82-5.52c.24-1.28,1.5-2.33,2.8-2.33h7.36v7.84ZM49.61,51.29h-12.15v-8h12.15v8ZM49.61,39.81h-12.15v-7.84h12.15v7.84ZM63.65,51.29h-12.15v-8h12.15v8ZM63.65,39.81h-12.15v-7.84h12.15v7.84ZM77.36,48.92c0,1.3-1.06,2.37-2.37,2.37h-9.45v-8h11.81v5.64ZM77.36,39.81h-11.81v-7.84h9.45c1.3,0,2.37,1.06,2.37,2.37v5.48Z"
			})
		] }),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-4",
			x: 7.17,
			y: 4.66,
			width: 85.67,
			height: 90.69,
			rx: 12,
			ry: 12
		})
	]
});
export default SvgParkTheBus;
